import React, { useEffect, useState } from "react";
import styled from "styled-components";
import useDisplay from "../../hooks/useDisplay";
import { useCookies } from "react-cookie";

import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

const HomePopup = ({ popupList, setPopupOpen }) => {
  const { isMobile } = useDisplay();
  const [cookies, setCookies] = useCookies();

  const popupCloseWithCookie = () => {
    const date = new Date();
    date.setDate(date.getDate() + 1);

    setCookies("PopupCookie", true, { path: "/", date });
    setPopupOpen(false);
  };

  return (
    <PopupDim $isMobile={isMobile}>
      <PopupWrapper $isMobile={isMobile}>
        <Swiper
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          pagination={true}
          modules={[Autoplay, Pagination]}
          className="popup"
          style={{ backgroundColor: "#fff" }}
        >
          {popupList?.map((item, index) => {
            return (
              <SwiperSlide key={index}>
                {item.fileUrl ? (
                  <img
                    src={item.fileUrl}
                    alt=""
                    style={{
                      width: "100%",
                      height: isMobile ? "288px" : "388px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      backgroundColor: "#fff",
                      width: "100%",
                      height: isMobile ? "288px" : "388px",
                    }}
                  ></div>
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div style={{ display: "flex" }}>
          <PopupBtn
            $isMobile={isMobile}
            onClick={popupCloseWithCookie}
            style={{ borderRight: "1px solid #F1F1F1" }}
          >
            오늘 하루 보지 않기
          </PopupBtn>
          <PopupBtn $isMobile={isMobile} onClick={() => setPopupOpen(false)}>
            닫기
          </PopupBtn>
        </div>
      </PopupWrapper>
    </PopupDim>
  );
};

export default HomePopup;

const PopupDim = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  padding: ${(props) => (props.$isMobile ? "0 20px" : "")};
`;

const PopupWrapper = styled.div`
  width: ${(props) => (props.$isMobile ? "335px" : "450px")};
  height: ${(props) => (props.$isMobile ? "335px" : "450px")};
  /* border: 1px solid#f1f1f1; */
  box-shadow: ${(props) =>
    props.$isMobile
      ? "5.956px 5.956px 26.056px 0px rgba(0, 0, 0, 0.45)"
      : "8px 8px 35px 0px rgba(0, 0, 0, 0.45)"};
`;

const PopupBtn = styled.div`
  flex: 1;
  height: ${(props) => (props.$isMobile ? "47.5px" : "62px")};
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  font-weight: 400;
  font-size: ${(props) => (props.$isMobile ? "13px" : "15px")};
  line-height: ${(props) => (props.$isMobile ? "135%" : "140%")};
  cursor: pointer;
`;
